import React from "react";
import styled from "styled-components";
import SliderOutcome from "../Components/SliderOutcome";
import Likert from '../Components/LikertOutcome';


const QuestionOutcome = ({
  question,
  saveUpdatedAnswers,
  currentQuestionDet,
  resetResponsesOnChange,
  questionSequenceMap,
  language,
  teamName,
  useLikert,
  organizationInfo,
  customHeader,
}) => {


  const getTitle = ()=>{
    if(currentQuestionDet?.fr_name && language === 'FR'){
      return currentQuestionDet?.fr_name
    } 
    if(currentQuestionDet?.es_name && language === 'ES'){
      return currentQuestionDet?.es_name
    }
    if(currentQuestionDet?.por_name && language === 'POR'){
      return currentQuestionDet?.por_name
    }

      return currentQuestionDet?.name
  }

  const getQuestion = ()=>{
    if(question?.fr && language === 'FR'){
      return question?.fr.replace('{entity}', teamName)
    } 
    if(question?.es && language === 'ES'){
      return question?.es.replace('{entity}', teamName)
    }
    if(question?.por && language === 'POR'){
      return question?.por.replace('{entity}', teamName)
    }

      return question?.question.replace('{entity}', teamName)
  }

  const getScaleType = () =>{
    if(useLikert && !currentQuestionDet?.useScale){
      return <Likert
      key={currentQuestionDet?.id}
      id={`slider-track-${currentQuestionDet?.id}`} 
      question={question} 
      language={language}
      useLikert={useLikert}
      saveUpdatedAnswers={saveUpdatedAnswers} 
      currentQuestionDet={currentQuestionDet} />
    }
    return <SliderOutcome
    key={currentQuestionDet?.id}
    id={`slider-track-${currentQuestionDet?.id}`}
    resetResponsesOnChange={resetResponsesOnChange}
    question={question}
    language={language}
    saveUpdatedAnswers={saveUpdatedAnswers}
    currentQuestionDet={currentQuestionDet}
    questionSequenceMap={questionSequenceMap}
  />
  }



  return (
    <QuestionContainer>
      {customHeader?.useImageAsQualifier && customHeader?.imageUrl ? (
        <HeaderImage
          src={customHeader.imageUrl}
          alt=""
          $height={customHeader.imageHeight}
        />
      ) : (
        <Title style={{color: organizationInfo?.custom_survey_header_color || undefined}}>
          {getTitle()}
        </Title>
      )}
      {/* <Qualifier>In this culture...</Qualifier>  */}
      <QuestionText >{getQuestion()}</QuestionText>
     {getScaleType()}
    </QuestionContainer>
  );
};
export default QuestionOutcome;

const QuestionContainer = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const HeaderImage = styled.img`
  display: block;
  max-width: 100%;
  height: ${props => (props.$height ? `${props.$height}px` : "auto")};
  margin-bottom: 40px;
`;

const Title = styled.div`
  color: #2d70e2;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 40px;
`;

const Qualifier = styled.div`
  color: #2a3039;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 14px;
`;

const QuestionText = styled.div`
  font-size: 16px;
  color: #2a3039;
  white-space: pre-wrap;
`;
